/** @format */

import * as React from "react";
import { createBrowserRouter, useNavigate } from "react-router-dom";

import Page404 from "src/errors/Page404.tsx";
import { useAlertsRoutes } from "src/routes/alerts.routes";
import { useBlacklistsRoutes } from "src/routes/blacklists.routes.tsx";
import { useCasesRoutes } from "src/routes/cases.routes.tsx";
import { useDevRoutes } from "src/routes/dev.routes.tsx";
import { importExportRoutes } from "src/routes/importExport.routes.ts";
import { jobsRoutes } from "src/routes/jobs.routes.ts";
import { reportingRoutes } from "src/routes/reporting.routes";
import { useRulesRoutes } from "src/routes/rules.routes.tsx";
import { useScenarioRoutes } from "src/routes/scenario.routes.tsx";

import ErrorBoundary from "../components/Errors/ErrorBoundary";
import AppLayout from "../pages/AppLayout";

import { useCustomersRoutes } from "./customers.routes";

const Home: React.FC = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    navigate("/alerts/notAssigned");
  }, [navigate]);

  return null;
};

export const useAppRouter = () => {
  const alertsRoutes = useAlertsRoutes();
  const rulesRoutes = useRulesRoutes();
  const casesRoutes = useCasesRoutes();
  const blacklistsRoutes = useBlacklistsRoutes();
  const scenarioRoutes = useScenarioRoutes();
  const devRoutes = useDevRoutes();
  const customersRoutes = useCustomersRoutes();

  return createBrowserRouter([
    {
      ErrorBoundary: ErrorBoundary,
      children: [
        {
          path: "/",
          Component: AppLayout,
          ErrorBoundary: ErrorBoundary,
          children: [
            {
              index: true,
              Component: Home,
              ErrorBoundary: ErrorBoundary,
            },
            ...importExportRoutes,
            ...reportingRoutes,
            ...jobsRoutes,
            ...rulesRoutes,
            ...casesRoutes,
            ...customersRoutes,
            ...blacklistsRoutes,
            ...scenarioRoutes,
            ...alertsRoutes,
            ...devRoutes,
            {
              path: "*",
              Component: Page404,
              ErrorBoundary: ErrorBoundary,
            },
          ],
        },
      ],
    },
  ]);
};
